import React from 'react';
import { cx } from 'react-emotion';
import { eztradStyling } from './EztradStyling';
import useShopId from '../../utils/useShopId';
import DynamicContent from '../DynamicContent';
import {
  Heading,
  Subheading,
  Text,
  Quote,
  WebLink,
  Image
} from './ContentComponents';

const contentComponents = {
  heading: Heading,
  subheading: Subheading,
  text: Text,
  quote: Quote,
  weblink: WebLink,
  image: Image
};

const EztradWrapper = ({ content, additionalComponents, className = '' }) => {
  const isEztrad = useShopId() === 'eztrad';

  return (
    <div className={cx(className, isEztrad && eztradStyling)}>
      <DynamicContent
        content={content}
        additionalComponents={{ ...contentComponents, ...additionalComponents }}
      />
    </div>
  );
};

export default EztradWrapper;
